<div>
    <app-country-list></app-country-list>
</div>

<div>
    <app-country-form></app-country-form>
</div>